var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({content: _vm.tooltipText, placement: _vm.tooltipPlacement}),expression:"{content: tooltipText, placement: tooltipPlacement}"}],staticClass:"base-button-icon",class:{
        'base-button-icon--active': _vm.isActive,
        'base-button-icon--circle': _vm.form === 'circle',
        'base-button-icon--gray': _vm.isGray,
        },on:{"click":function($event){return _vm.$emit('onBaseButtonIcon')}}},[_c('span',{staticClass:"base-button-icon__icon",class:'icon-'+ _vm.iconName})])}
var staticRenderFns = []

export { render, staticRenderFns }